import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/ic_upload_pictures.png'
import _imports_1 from '../../images/delete_icon.png'
import _imports_2 from '../../images/img_top-up_success.png'
import _imports_3 from '../../images/yyzj_mistake.jpg'


const _withScopeId = n => (_pushScopeId("data-v-12e534f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "create-image" }
const _hoisted_2 = {
  key: 0,
  class: "info"
}
const _hoisted_3 = { class: "tipInfo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "上传图片"
  }),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","margin-top":"12px","font-weight":"400","color":"#9D9D9D"} }, "上传图片")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-cover van-ellipsis" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "info",
  style: {"margin-top":"86px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"500","color":"#000000","margin-top":"22px"} }, "您已成功上传 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"400","color":"#9D9D9D","font-size":"14px","margin-top":"12px"} }, "请等待电脑端同步上传结果", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "btn-box"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "diaTitle" }, "营业执照上传须知")
], -1))
const _hoisted_13 = { style: {"margin":"10px 14px","border-bottom":"1px solid #ECECEC","position":"relative"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "orangeTitle" }, " 错误：法人不对 ", -1))
const _hoisted_15 = { class: "dialogHead" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialogTitle" }, "识别失败", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialogBac" }, null, -1))
const _hoisted_18 = { class: "dialogText" }

import { watch, onMounted, reactive, ref ,onActivated} from "vue";
import axios from 'axios';
import { message } from "ant-design-vue"
import {extractUrlQueryParams, fileToBase64WithName} from '../../utils'

export default /*#__PURE__*/_defineComponent({
  __name: 'uploadYyzz',
  setup(__props) {

const imgR = require('../../images/yyjz_right.jpg')
const imgW = require('../../images/yyzj_mistake.jpg')
const show = ref(false)
const body = ref<any>(null)
const imgIndex = ref(0);
const fileList = ref([]as string[]);
const successFlag = ref(false)
const canSubmit = ref(false)
onMounted(() => {
  document.title = '营业执照上传'
})
const imagePreview = ref<Array<any>>([])
const loadingUp = ref(false);
const picLoading = ref(false);
const titleList = ['提示一','提示二','提示三','提示四'];
const bannerList = ['提示一','提示二','提示三','提示四'];
const onChange = (newIndex:any) => {
  imgIndex.value = newIndex;
};
const showHelpTips = ref('');
const showDialog = ref(false);
const showBottom = ref(false);
const activeTitle = ref('');
const activeBanner = ref('');
const removeSuffixIfPresent = (str:any) =>  {
  return str.replace("https://c1.yaofangwang.net/", "");
}
const underRules = ()=>{
  canSubmit.value = true;
  showBottom.value = false;
}
const resetPic =()=>{
  fileList.value = [];
  showDialog.value = false;
}
const showImg = (type:any)=>{
  if(type == 1){
    imagePreview.value = [imgR]
  }else{
    imagePreview.value = [imgW]
  }
  show.value = true;
}
const hasMounted = ref(false)
const submit = async () => {
  if(picLoading.value){
    message.warning('请等待图片上传完成后提交');
    return
  }
  if(!fileList.value||!fileList.value.length){
    return
  }
  if(!canSubmit.value){
    showRules();
    return
  }
  let arr:any = []
  fileList.value.forEach(item=>{
    if(item&&item.url){
      arr.push(removeSuffixIfPresent(item.url))
    }
  })
  let imageUrl = arr.join(',')
  const params = extractUrlQueryParams(window.location.href);
  const postData = new FormData()
  postData.append("shopId", params.shopId)
  postData.append("imageUrl", imageUrl)
  postData.append("ssid", params.ssid)
  loadingUp.value = true;
  axios.post('https://api-erp.yaofangwang.com/common.handle.saveBusinessLicenseForH5', postData)
    .then((response) => {
      if (response.data?.code == 1&&response.data.result?.checkStatus == 1){
        loadingUp.value = false;
        successFlag.value = true;
      }else{
        console.log(response.data.result?.failMessage ,'response.data.result?.failMessage ')
        loadingUp.value = false;
        showHelpTips.value = response.data.msg?response.data.msg: response.data.result?.failMessage||'请确认拍摄完整，光线充足！'
        showDialog.value = true;
      }
    })
    .catch((error) => {
      loadingUp.value = false;
      showHelpTips.value = '请确认拍摄完整，光线充足！'
      showDialog.value = true;
    });
}

const beforeRead = async (file:any) => {
  // 检查文件类型
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('只能上传jpg或png格式的图片！');
    return Promise.reject(file);
  }

  // 检查文件大小
  const isLt2M = file.size / 1024 / 1024 < 5;
  if (!isLt2M) {
    message.error('图片大小不能超过5MB！');
    return Promise.reject(file);
  }
  
};
const afterRead = async (filelist:any) => {
  filelist.status = 'uploading';
  filelist.message = '上传中...';
  const {file} = filelist;
  picLoading.value = true;
  try {
    const formData = new FormData();
    const {fileName , base64} = await fileToBase64WithName(file)
    formData.append('fileName',fileName);
    formData.append("fileBase64",base64)
    const params = extractUrlQueryParams(window.location.href);
    formData.append("ssid", params.ssid)
     
    // 发起 POST 请求进行文件上传
    const response = await axios.post('https://api-erp.yaofangwang.com/common.handle.uploadForH5', formData, {
      headers: {
        // 'Content-Type': 'multipart/form-data', // 设置正确的Content-Type
      },
    });

    if (response.status === 200&& response.data.code === 1) {
      filelist.status = 'success';
      filelist.message = '';
      // 上传成功，将返回的 URL 添加到 fileList
      fileList.value[0].url ='https://c1.yaofangwang.net/'+ response.data.result ;
      message.success('上传成功');
    } else {
      fileList.value = [];
      message.error('上传失败,请重试');
      picLoading.value = false;
    }
  } catch (error) {
    fileList.value = [];
    message.error('上传失败,请重试');
    picLoading.value = false;
  } finally {
    picLoading.value = false;
  }
};
const onChangeSwipe = (index:any)=>{
  activeTitle.value = titleList[index];
  activeBanner.value = bannerList[index];
}
const showRules = ()=>{
  showBottom.value = true;
  activeTitle.value = titleList[0];
  activeBanner.value = bannerList[0];
}
onMounted(()=>{
  if(!hasMounted.value){
    hasMounted.value = true;
    showRules()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_image_preview = _resolveComponent("van-image-preview")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-content",
    ref: (ref) => (body.value = ref)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!successFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showImg(1)))
              }, "查看示例")
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_van_uploader, {
                modelValue: fileList.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fileList).value = $event)),
                "max-count": 1,
                "before-read": beforeRead,
                "after-read": afterRead
              }, {
                "preview-cover": _withCtx(({ file }) => [
                  _hoisted_5
                ]),
                "preview-delete": _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_1,
                    style: {"width":"24px","position":"absolute","right":"-8px","top":"0","cursor":"pointer"},
                    alt: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (fileList.value = []))
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10)),
      (!successFlag.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: submit,
              loading: loadingUp.value,
              class: _normalizeClass(!fileList.value.length?'hidTransf':'')
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["loading", "class"])
          ]))
        : _createCommentVNode("", true),
      (showBottom.value)
        ? (_openBlock(), _createBlock(_component_van_popup, {
            key: 3,
            show: showBottom.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showBottom).value = $event)),
            round: "",
            position: "bottom",
            closeable: "",
            style: { height: '384px',display:'flex',flexDirection: 'column'}
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _imports_3,
                  style: {"height":"260px"},
                  alt: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showImg(2)))
                }),
                _hoisted_14
              ]),
              _createVNode(_component_a_button, {
                style: {"margin":"0px 14px"},
                type: "primary",
                onClick: underRules
              }, {
                default: _withCtx(() => [
                  _createTextVNode("我已知晓规则，开始拍摄")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_dialog, {
      show: showDialog.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
      title: "",
      showConfirmButton: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_van_icon, {
            name: "cross",
            size: "13",
            class: "dialogClose",
            onClick: resetPic
          }),
          _hoisted_17
        ]),
        _createElementVNode("div", _hoisted_18, _toDisplayString(showHelpTips.value), 1),
        _createVNode(_component_van_button, {
          beforeClose: resetPic,
          type: "primary",
          style: {"width":"240px","margin":"20px 0px 0px 0px"},
          onClick: resetPic
        }, {
          default: _withCtx(() => [
            _createTextVNode("重新拍摄")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_image_preview, {
      show: show.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((show).value = $event)),
      images: imagePreview.value,
      onChange: onChange
    }, {
      index: _withCtx(() => [
        _createTextVNode(_toDisplayString(imgIndex.value+1+'/'+imagePreview.value.length), 1)
      ]),
      _: 1
    }, 8, ["show", "images"])
  ], 512))
}
}

})